const Account = ({ color = "#0E0E0E" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="8" r="3.25" stroke={color} strokeWidth="1.5" />
      <path
        d="M6.00176 18.2375C6.76267 15.6432 9.16122 13.75 12 13.75C14.8388 13.75 17.2373 15.6432 17.9982 18.2375C18.0725 18.4907 18.0079 18.717 17.8365 18.9043C17.654 19.1037 17.3505 19.25 17 19.25H7C6.64953 19.25 6.34601 19.1037 6.16354 18.9043C5.99212 18.717 5.92749 18.4907 6.00176 18.2375Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Account;
